import { forkJoin, map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiTransferConfigService } from './api-transfer-config.service';
import { IGenericResult } from 'src/app/models/generic';
import { environment } from 'src/environments/environment';
import {
  IReverseConfig,
  IReverseConfigParameters
} from 'src/app/models/reverseConfig';

@Injectable({
  providedIn: 'root'
})
export class ApiReverseConfigService {
  //baseUrlReverseConfig = `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.reversalParameter}`;
  baseUrlReverseConfig = `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferReversalParamter}`;

  constructor(
    private _http: HttpClient,
    private _transferConfigService: ApiTransferConfigService
  ) {}

  getParametersReverseConfig(): Observable<IReverseConfigParameters> {
    const bank$ = this._transferConfigService.getBank();
    const channel$ = this._transferConfigService.getChannel();
    const contractStatus$ = this._transferConfigService.getContractStatus();

    const parameters$ = forkJoin([bank$, channel$, contractStatus$]).pipe(
      map(([bank, channel, contractStatus]) => {
        let parameters: IReverseConfigParameters = {
          bank,
          channel,
          contractStatus,
          reverseType: ['Integral', 'Parcial (R$)', 'Parcial (%)'].map(
            (type) => {
              return { id: type.toLowerCase(), name: type };
            }
          )
        };

        return parameters;
      })
    );

    return parameters$;
  }

  getReverseConfig(
    skip: number,
    take: number,
    hasDocument: boolean = false
  ): Observable<IGenericResult<IReverseConfig[]>> {
    return this._http.get<IGenericResult<IReverseConfig[]>>(
      `${this.baseUrlReverseConfig}?skip=${skip}&take=${take}&hasDocument=${hasDocument}`
    );
  }

  saveReverseConfig(
    reverseConfig: IReverseConfig
  ): Observable<IGenericResult<IReverseConfig>> {
    return this._http.post<IGenericResult<IReverseConfig>>(
      this.baseUrlReverseConfig,
      reverseConfig
    );
  }

  deleteReverseConfig(reverseConfigId: string): Observable<any> {
    return this._http.delete<any>(
      `${this.baseUrlReverseConfig}/${reverseConfigId}`
    );
  }
}
